/**
 * 考试预览
 * @description 考试预览
 * @author hxliu
 * @date 2020-3-27
 */
import React from 'react';
import { connect } from 'dva';
import { parse } from "querystring";
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizContainer, ossFileUtils } = framework_tool
import { ExamPreview } from '../../../../components'
import { modelUtils } from '@/utils';
let { Session } = utils_tool;
let { WizUpload, WizIcon, WizButton } = component_tool;
import { Spin } from 'antd'

const getParamRecord = (history) => {
    let record = 0
    if (history.location) {
        if (history.location.pathname === '/online/exam/examInfo' || history.location.pathname === '/online/examRecord/examInfo') {
            if (history.location && history.location.record) {
                record = history.location.record['id']
                Session.set('examChapterId', record)
            } else {
                record = Session.get('examChapterId') || 0
            }
        }
    } else {
        record = Session.get('examChapterId') || 0
    }

    /**
     * 兼容页面带参数的方式
     */
    const getPageQuery = () => parse(window.location.href.split("?")[1]);
    const { id } = getPageQuery();
    if (id && id !== '') {
        record = id
    }
    return record
}

class ExamInfo extends WizContainer {

    componentName = 'ExamInfo';

    constructor(props) {
        super(props);
        let id = 0;
        id = getParamRecord(props.history)
        this.state = {
            id
        };
        this.categoryType = 'create'//分类类型初始未新增点击修改时
        this.type = 'static'//分类类型初始未新增点击修改时
    }

    componentDidMount() { }

    componentWillMount() {
        this.doActions([
            {
                path: 'exam/previewInfo',
                payload: {
                    key: 'previewInfoKey',
                    apiParams: {
                        id: this.state.id
                    }
                }
            },
        ]);
    }

    propsAndStateOnChange = {
        previewInfo: this._previewInfo.bind(this),

    };

    _previewInfo(nextProps, nextState) {
        let previewInfo = nextProps['previewInfo'];
        if (previewInfo && previewInfo['success']) {
            let data = []
            if (previewInfo['data']) {
                if (previewInfo['data']['parts'] && previewInfo['data']['parts'] instanceof Array) {
                    previewInfo['data']['parts'].forEach((part, index) => {
                        if (part['questions'] && part['questions'] instanceof Array) {
                            part['questions'].forEach((question, index) => {
                                //题目图片
                                if (question['img'] && question['img'] != '') {
                                    question['img'] = getOssFilePath(question['img']);
                                } else {
                                    question['img'] = undefined
                                }
                                if (question['type'] === 1) {
                                    question['correct'] = question['correct'].split(',').map(p => parseInt(p))
                                }
                                if (question['type'] === 2 || question['type'] === 0) {
                                    question['correct'] = parseInt(question['correct'])
                                }
                                if (question['type'] === 3) {
                                    let answerObj = JSON.parse(question['correct'])
                                    // let answer = new Array();
                                    // for (let i = 0; ; i++) {
                                    //     const answerKey = 'keys' + i;
                                    //     const answerCurrent = 'answer' + i;
                                    //     if (answerObj[answerKey] === undefined) {
                                    //         break;
                                    //     } else {
                                    //         answer[i] = new Array();
                                    //         for (let j = 0; j < answerObj[answerKey].length; j++) {
                                    //             answer[i][j] = answerObj[answerCurrent][answerObj[answerKey][j]]
                                    //         }
                                    //     }
                                    // }
                                    question['correct'] = answerObj
                                }
                                let options = question['options']
                                if (options && options.length) {
                                    options.forEach(o => {
                                        if (o['fileUri'] && o['fileUri'] != '') {
                                            o['img'] = ossFileUtils.getOssUrlBySuffix(o['fileUri']);
                                        }
                                    });
                                }
                            })
                        }

                    })
                }

            }
            nextState['data'] = previewInfo['data']
        }
        return true;
    }
    _render() {
        const { data } = this.state
        let { examLoading } = this.props
        return (
            <Spin tip={'加载中'} spinning={examLoading}>
                <ExamPreview data={data || {}} />
            </Spin>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { exam } = state;
    const previewInfo = modelUtils.getModelEntity(exam, "previewInfoKey");
    const load = modelUtils.getLoadingState(state, ['exam']);
    return {
        previewInfo,
        ...load
    };
};

export default connect(mapStateToProps)(ExamInfo);
